import { render, staticRenderFns } from "./ViolationCrud.vue?vue&type=template&id=7c8af767"
import script from "./ViolationCrud.vue?vue&type=script&lang=js"
export * from "./ViolationCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports